import { createAction } from 'redux-actions'

export const setSession = createAction('SESSION_SET')

export const logIn = createAction('LOG_IN_STARTED')
export const logInSuccess = createAction('LOG_IN_SUCCEED')
export const logInFail = createAction('LOG_IN_FAILED')

export const signUp = createAction('SIGN_UP_STARTED')
export const signUpSuccess = createAction('SIGN_UP_SUCCEED')
export const signUpFail = createAction('SIGN_UP_FAILED')

export const authChecked = createAction('AUTH_CHECKED')



// WEBPACK FOOTER //
// ./src/store/actions/auth.js